import { spaceGroupLongNames, spaceGroupShortNames } from '../../constants/SpaceGroups'

import concat from 'lodash/concat'
import filter from 'lodash/filter'
import indexOf from 'lodash/indexOf'

export function rank(results) {
  const anomalous = filter(results, function (o) {
    return (
      o.v_datacollection_summary_phasing_anomalous &&
      (o.v_datacollection_processingStatus === 'SUCCESS' ||
        o.v_datacollection_processingStatus === 1 ||
        o.v_datacollection_processingStatus === '1')
    )
  })
  const nonanomalous = filter(results, function (o) {
    return (
      o.v_datacollection_summary_phasing_anomalous === false &&
      (o.v_datacollection_processingStatus === 'SUCCESS' ||
        o.v_datacollection_processingStatus === 1 ||
        o.v_datacollection_processingStatus === '1')
    )
  })
  const running = filter(results, function (o) {
    return o.v_datacollection_processingStatus === 'RUNNING'
  })
  const failed = filter(results, function (o) {
    return o.v_datacollection_processingStatus === 'FAILED' || o.v_datacollection_processingStatus === 0
  })

  const anomalousdata = sort(anomalous, 'v_datacollection_summary_phasing_autoproc_space_group')
  const nonanomalousdata = sort(nonanomalous, 'v_datacollection_summary_phasing_autoproc_space_group')

  return concat(nonanomalousdata, anomalousdata, running, failed)
}

function sort(array, spacegroudFieldName) {
  /** First sorting autoprocessing with rMerge < 10 */
  const minus10Rmerge = filter(array, function (o) {
    if (o.innerShell) {
      if (o.innerShell.rMerge) {
        if (Number(o.innerShell.rMerge) <= 10 && Number(o.innerShell.rMerge) > 0) {
          return true
        }
      }
    }
    return false
  })

  /** Second we get rMerge > 10 */
  const plus10Rmerge = filter(array, function (o) {
    if (o.innerShell) {
      if (o.innerShell.rMerge) {
        if (Number(o.innerShell.rMerge) > 10 || Number(o.innerShell.rMerge) <= 0) {
          return true
        }
      }
    }
    return false
  })

  function sortByHighestSymmetry(a, b) {
    const spaceGroupA = a[spacegroudFieldName].replace(/\s/g, '')
    const spaceGroupB = b[spacegroudFieldName].replace(/\s/g, '')

    let indexOfSpaceGroupA = indexOf(spaceGroupShortNames, spaceGroupA)
    if (indexOfSpaceGroupA === -1) {
      /** If not found check with long name */
      indexOfSpaceGroupA = indexOf(spaceGroupLongNames, spaceGroupA)
    }

    let indexOfSpaceGroupB = indexOf(spaceGroupShortNames, spaceGroupB)
    if (indexOfSpaceGroupB === -1) {
      indexOfSpaceGroupB = indexOf(spaceGroupLongNames, spaceGroupB)
    }

    if (indexOfSpaceGroupA === indexOfSpaceGroupB) {
      return parseFloat(a.innerShell.rMerge) - parseFloat(b.innerShell.rMerge)
    }
    return indexOfSpaceGroupB - indexOfSpaceGroupA
  }

  function sortByrMerge(a, b) {
    return parseFloat(a.innerShell.rMerge) - parseFloat(b.innerShell.rMerge)
  }

  minus10Rmerge.sort(sortByHighestSymmetry)
  plus10Rmerge.sort(sortByrMerge)

  /** Setting lables */
  if (plus10Rmerge) {
    for (let i = 0; i < plus10Rmerge.length; i++) {
      plus10Rmerge[i].label = 'rMerge > 10'
    }
  }

  return concat(minus10Rmerge, plus10Rmerge)
}
